import { ReactElement } from 'react';

import { Link, LinkTarget } from '@dreryk/react-components';

import { mfaRequiredTranslationKeys } from '../../translations';

const HELP_CENTER_LINK =
   'https://centrumpomocy.egabinet.dreryk.pl/pierwsze-kroki/logowanie-do-aplikacji#logowanie-dwuetapowe';

export const MfaRequiredHelpCenterLink = (): ReactElement => {
   return (
      <Link
         testId={'goToHelpCenter'}
         block={false}
         href={HELP_CENTER_LINK}
         label={mfaRequiredTranslationKeys.goToHelpCenter}
         target={LinkTarget.BLANK}
      />
   );
};
